const categoryVariantClasses = 'site-paragraph-xs text-site-neutrals-400 mb-1';

const containerVariantClasses = 'py-6';

const minutesReadVariantClasses = '';

const summaryVariantClasses = '';

const titleVariantClasses = 'site-paragraph-xl font-bold text-site-neutrals-700';

const snackbarSiteTheme = {
  categoryVariantClasses,
  containerVariantClasses,
  minutesReadVariantClasses,
  summaryVariantClasses,
  titleVariantClasses,
};

export default snackbarSiteTheme;
